import { DataMapper } from 'modules/core/domain/interfaces/data-mapper';
import { normalizePhone } from 'shared/utils/normalize-phone';
import { LatestTournament } from '../interfaces/latest-tournament';
import { Organizer } from '../interfaces/organizer';
import { OrganizerInfoDto } from '../interfaces/organizer-dto';
import { SportType } from 'modules/core/domain/enums/sport-type';

export class OrganizerDataMapper implements DataMapper<Organizer, OrganizerInfoDto> {
  public decode(payload: OrganizerInfoDto): Organizer {
    const tournament = payload;
    // Backend already returns championships in the desired sorted order via championshipsPaginated
    const latestTournaments = tournament.championships.slice(0, 5).map(
      (item) =>
        ({
          id: item.id,
          name: item.name,
          startDate: item.startDate,
          endDate: item.endDate,
        }) as LatestTournament,
    );

    const logo = tournament.images.find((image) => image.type === 'logo');

    return {
      id: tournament.id,
      name: tournament.name,
      sportType: tournament.sportType as SportType,
      logoUrl: logo?.externalUrl,
      email: tournament.email,
      phone: tournament.phone ? normalizePhone(tournament.phone) : undefined,
      description: tournament.description,
      latestTournaments,
      address: tournament.address,
    } as Organizer;
  }

  public encode(payload: Organizer): OrganizerInfoDto {
    return {
      id: payload.id,
      name: payload.name,
      sportType: payload.sportType,
      email: payload.email,
      phone: payload.phone,
      description: payload.description,
      championships: payload.latestTournaments.map((item) => ({
        id: item.id,
        name: item.name,
        startDate: item.startDate,
        endDate: item.endDate,
      })),
      images: payload.logoUrl
        ? [
            {
              type: 'logo',
              externalUrl: payload.logoUrl,
            },
          ]
        : undefined,
      address: {
        city: payload.address?.city ?? undefined,
        country: payload.address?.country ?? undefined,
        region: payload.address?.region ?? undefined,
      },
    } as OrganizerInfoDto;
  }
}
